var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3810_11475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 28.0003H8C6.93913 28.0003 5.92172 27.5789 5.17157 26.8288C4.42143 26.0786 4 25.0612 4 24.0003V22.667H11.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 11.3333V6.66667C22.6665 6.13925 22.8229 5.62368 23.1159 5.18515C23.4089 4.74662 23.8254 4.40482 24.3127 4.20299C24.8 4.00116 25.3361 3.94835 25.8534 4.05124C26.3707 4.15413 26.8458 4.40811 27.2188 4.78105C27.5917 5.15399 27.8457 5.62914 27.9486 6.14643C28.0515 6.66371 27.9987 7.19989 27.7968 7.68716C27.595 8.17443 27.2532 8.5909 26.8147 8.88392C26.3762 9.17694 25.8606 9.33333 25.3332 9.33333H22.6665",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 4H10.6665C9.60564 4 8.58822 4.42143 7.83808 5.17157C7.08793 5.92172 6.6665 6.93913 6.6665 8V22.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33301H17.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.667H17.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.56 16.8133C25.0851 16.2882 25.7974 15.9932 26.54 15.9932C27.2826 15.9932 27.9949 16.2882 28.52 16.8133C29.0451 17.3384 29.3401 18.0507 29.3401 18.7933C29.3401 19.536 29.0451 20.2482 28.52 20.7733L20 29.3333H16V25.3333L24.56 16.8133Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3810_11475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEditWhite);
export default __webpack_public_path__ + "static/media/file-edit-white.c22ab39ffc58b8b0561fc56987746169.svg";
export { ForwardRef as ReactComponent };